(function (window, document) {
    'use strict';

    var host = window.location.hostname;

    var domainScriptId = null;

    if (host === 'billing.dhlparcel.be') {
        domainScriptId = '019c762a-1540-7635-8fe6-c7cdcd81c551';
    } else if (host === 'billing.dhlparcel.nl') {
        domainScriptId = '019c762b-1357-7e6e-a444-d326ad1dc30b';
    } else if (host === 'dhl.nl.qas-benelux.edistrada.pl') {
        domainScriptId = '019c762a-1540-7635-8fe6-c7cdcd81c551-test'; // QAS single
    } else {
        return; // lokalnie/inne hosty: nie ładuj
    }

    // wymagane przez OneTrust
    window.OptanonWrapper = window.OptanonWrapper || function () {};

    // uniknij podwójnego ładowania
    if (document.querySelector('script[data-onetrust="true"]')) return;

    var s = document.createElement('script');
    s.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    s.type = 'text/javascript';
    s.charset = 'UTF-8';
    s.setAttribute('data-domain-script', domainScriptId);
    s.setAttribute('data-onetrust', 'true');

    document.head.appendChild(s);

})(window, document);
